import { Box, useStyleConfig } from '@chakra-ui/react';

function AppBox({ size, variant, children, customStyles, onClick }) {
  const styles = useStyleConfig('AppBox', { size, variant });
  return (
    <Box sx={styles} {...customStyles} onClick={onClick}>
      {children}
    </Box>
  );
}

export default AppBox;
